// extracted by mini-css-extract-plugin
export default {"MessagesPopup":"MessagesPopup_MessagesPopup__jF74P"};